import React from 'react';
import ReactDOM from 'react-dom';

import Banner from "@/common/banner/Banner";

const element = document.querySelector('[data-view="banner"]');

if (element) {
    ReactDOM.render(
        <Banner />,
        element
    );
}
